import Icon from "../../components/Icon";
import SelectableCard from "../../components/SelectableCard";
import SkeletonAddressesList from "../../components/SkeletonAddressesList";
import { EVENT_TYPES, logEvent } from "../../helpers/analytics-helper";
import useNavigation from "../../hooks/useNavigation";
import {
  Address,
  LogisticScheduledTaskAddress,
  TransportationType,
} from "../../types/server";
import { addressToScheduledAddress } from "./SelectAddressSection-helpers";
import { Typography, Stack, Button, Divider, Box } from "digiwash-components";
import React from "react";
import useSyncFilterWithParam from "../../hooks/useSyncFilterWithParam";
import { Platform } from "react-native";

interface PropTypes {
  data: Address[];
  loading?: boolean;
  type: TransportationType;
  onSelect: (item: LogisticScheduledTaskAddress) => void;
  selectedAddressId?: any;
  disabledFor?: string;
  isInPerson?: boolean;
  origin_page: string;
  order_id?: number;
}

SelectAddressSection.defaultProps = {
  type: "collection",
};
function SelectAddressSection(props: PropTypes) {
  let { setParam } = useSyncFilterWithParam();
  let nav = useNavigation();

  return (
    <>
      {props.loading && <SkeletonAddressesList />}
      {!props.disabledFor && !props.loading && (
        <>
          {props.data &&
            props.data.map((item) => {
              return (
                <React.Fragment key={item.id}>
                  <SelectableCard
                    title={item.title}
                    desc={item.address}
                    onPress={() => {
                      logEvent(EVENT_TYPES.BUTTON_SELECT_ADDRESS);
                      props.onSelect(addressToScheduledAddress(item));
                    }}
                    selected={item.id === props.selectedAddressId}
                  />
                  <Divider size="m" />
                </React.Fragment>
              );
            })}
          {!props.isInPerson ? (
            <>
              <Divider size="m" />
              <Stack distribution="end">
                <Button
                  fill="white"
                  prefix={<Icon name="plus" size={16} color="primary.main" />}
                  onPress={() => {
                    logEvent(EVENT_TYPES.BUTTON_ADD_ADDRESS);
                    if (Platform.OS === "web") {
                      nav.navigate("NewAddress");
                      setParam({
                        name: "origin_page",
                        value: props.origin_page,
                      });
                      if (props.order_id) {
                        setParam({
                          name: "order_id",
                          value: String(props.order_id),
                        });
                      }
                    } else if (Platform.OS === "android") {
                      nav.navigate("NewAddress", {
                        origin_page: props.origin_page,
                        order_id: props.order_id
                          ? String(props.order_id)
                          : null,
                      });
                    }
                  }}
                >
                  اضافه کردن آدرس جدید
                </Button>
              </Stack>
            </>
          ) : null}
        </>
      )}

      {props.disabledFor && (
        <Box py="l">
          <Typography ff="mainBold" alignment="center" color="neutrals.700">
            {props.disabledFor}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default SelectAddressSection;
